export type Location = {
  name: string;
  region: string;
  url: string;
  image: string;
  coords: [number, number]; // [lng, lat]
};

export const locations: Location[] = [
  {
    name: "Alaska",
    region: "Anchorage · Wasilla · Mat-Su",
    url: "https://www.kristancole.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/kathrine-coonjohn-twG_u1iugdA-unsplash-scaled-e1700580500377-1024x684.jpg",
    coords: [-149.9, 61.2],
  },
  {
    name: "Greater Phoenix, AZ",
    region: "Scottsdale · Mesa · Phoenix",
    url: "http://www.lifestylehomesofthegreaterphoenixarea.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/james-day-bL_K801gcKI-unsplash-scaled-e1700580562446-1024x672.jpg",
    coords: [-112.07, 33.45],
  },
  {
    name: "Los Angeles, CA",
    region: "Greater LA",
    url: "https://www.lifestylehomesworldwide.com/los_angeles",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/olenka-kotyk-9TUkYXQKXec-unsplash-1024x683.jpg",
    coords: [-118.24, 34.05],
  },
  {
    name: "North Shore, WI",
    region: "Milwaukee North Shore",
    url: "https://www.lifestylehomesworldwide.com/north_shore_wisconsin",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/dave-hoefler-ESamRYrzU0Q-unsplash-1024x683.jpg",
    coords: [-87.9, 43.17],
  },
  {
    name: "Northern AZ",
    region: "Flagstaff · Sedona · Prescott",
    url: "https://lifestylehomesofnorthernarizona.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/edmundo-mendez-jr-dJXZAO9hVjw-unsplash-1024x683.jpg",
    coords: [-111.65, 35.2],
  },
  {
    name: "Northern MI",
    region: "Traverse City · Up North",
    url: "https://www.lifestylehomesworldwide.com/northern_michigan",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/jason-brower-q25Ma5T3O1I-unsplash-scaled-e1700580439467-1024x681.jpg",
    coords: [-85.62, 44.76],
  },
  {
    name: "Fort Myers, FL",
    region: "Southwest Florida",
    url: "https://www.dennygrimes.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/olenka-kotyk-9TUkYXQKXec-unsplash-1024x683.jpg",
    coords: [-81.87, 26.64],
  },
  {
    name: "Naples, FL",
    region: "Southwest Florida",
    url: "https://www.dennygrimes.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/olenka-kotyk-9TUkYXQKXec-unsplash-1024x683.jpg",
    coords: [-81.79, 26.14],
  },
  {
    name: "Omaha, NE",
    region: "Greater Omaha",
    url: "https://www.lifestylehomesworldwide.com/omaha",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/jesse-duering-BU1X9zjVLpI-unsplash-1024x682.jpg",
    coords: [-95.93, 41.26],
  },
  {
    name: "Southern AZ",
    region: "Tucson",
    url: "https://lifestylehomesofsouthernarizona.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/robert-murray-toCqTyxsT4Q-unsplash-1024x680.jpg",
    coords: [-110.93, 32.22],
  },
  {
    name: "The White Mountains, AZ",
    region: "Show Low · Pinetop",
    url: "https://lifestylehomesofthewhitemountains.com/",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/rylan-hill-RzPdxEP__Vc-unsplash-1024x682.jpg",
    coords: [-110.03, 34.25],
  },
  {
    name: "Wichita, KS",
    region: "South Central Kansas",
    url: "https://www.lifestylehomesworldwide.com/wichita",
    image:
      "https://joinkcn.com/wp-content/uploads/2023/11/jolene-phimmasone-9YXG8VmQgPU-unsplash-scaled-e1700580532828-1024x681.jpg",
    coords: [-97.34, 37.69],
  },
];

